import { generateTestId } from "@client-shared";

export const setDashboardViewTestId = (identifier: string): string => generateTestId("DashboardView", identifier);

// Container
export const setDashboardViewContainerTestId = (): string => setDashboardViewTestId("container");

// Header elements
export const setDashboardViewGreetingTestId = (): string => setDashboardViewTestId("greeting");

export const setDashboardViewSubtitleTestId = (): string => setDashboardViewTestId("subtitle");

export const setDashboardViewExportButtonTestId = (): string => setDashboardViewTestId("export-button");

// Chart grid
export const setDashboardViewChartGridTestId = (): string => setDashboardViewTestId("chart-grid");

// Last updated
export const setDashboardViewLastUpdatedTestId = (): string => setDashboardViewTestId("last-updated");
